var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { memo } from 'react';
import { AnimatePresence } from 'framer-motion';
import { NavLink } from 'react-router-dom';
import { StyledNavigation, Ul, Li } from './NavigationMobile.Styles';
var variants = {
    open: {
        duration: 1000,
        height: 'auto',
        display: 'block',
        transition: { staggerChildren: 0.07, delayChildren: 0.3 }
    },
    closed: {
        duration: 1000,
        height: 0,
        display: 'none',
        transition: { staggerChildren: 0.05, staggerDirection: -1 }
    }
};
export var NavigationMobile = memo(function (_a) {
    var isOpen = _a.isOpen, links = _a.links;
    return (React.createElement(AnimatePresence, { initial: false },
        React.createElement(StyledNavigation, { animate: isOpen ? 'open' : 'closed', variants: variants },
            React.createElement(Ul, { variants: variants }, links.map(function (link, index) {
                return React.createElement(Item, __assign({ key: index }, link));
            })))));
});
var liVariants = {
    open: {
        y: 0,
        opacity: 1,
        display: 'block',
        transition: {
            y: { stiffness: 1000, velocity: -100 }
        }
    },
    closed: {
        y: -30,
        opacity: 0,
        display: 'none',
        transition: {
            y: { stiffness: 1000 }
        }
    }
};
export var Item = memo(function (_a) {
    var link = _a.link, title = _a.title;
    return (React.createElement(Li, { variants: liVariants, whileHover: { scale: 1.1 }, whileTap: { scale: 0.95 } },
        React.createElement(NavLink, { to: link }, title)));
});
